import request from '@/utils/request'
const BASE_URL = '/BstrIn'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  submit(data) {
    return request({
      url: BASE_URL + '/Submit',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  getMaxOrderId() {
    return request({
      url: BASE_URL + '/GetMaxOrderId',
      method: 'get',
    })
  },
  getChecklogs(data) {
    return request({
      url: BASE_URL + '/GetChecklogs',
      method: 'post',
      data
    })
  },
  pass(id) {
    return request({
      url: BASE_URL + '/Pass',
      method: 'get',
      params: { id }
    })
  },
  noPass(id) {
    return request({
      url: BASE_URL + '/NoPass',
      method: 'get',
      params: { id }
    })
  },
  cancelReview(id) {
    return request({
      url: BASE_URL + '/CancelReview',
      method: 'get',
      params: { id }
    })
  },
}